export const ENABLE = 'closedTestingActions/enable';
export const enable = (value) => ({ type: ENABLE, payload: value });
